import React from 'react'
import { connect } from 'react-redux'

import { ResultsCount } from '..'

const ConnectedResultsCount = props => {
    return props.total ? <ResultsCount {...props} /> : null
}

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ results }) => {
    const offset = (results.page - 1) * results.pageSize

    return {
        total: results.count,
        first: offset + 1,
        last: offset + results.items.length,
    }
}

export default connect(mapStateToProps)(ConnectedResultsCount)
